import { ShopifyApi } from '../../generated/api';
import configuration from './configuration';

export default new ShopifyApi(configuration);
